export let navbar = [
    {
        "role":"user",
        "name":"Mood Tracker",
        "link":"/dashboard",
    },
    {
        "role":"user",
        "name":"Forum",
        "link":"/forum",
    },
    {
        "role":"user",
        "name":"Translate via Voice",
        "link":"/signt",
    },{
        "role":"user",
        "name":"Translate via Text",
        "link":"/texttrans",
    },
    {
        "role":"user",
        "name":"helpful Articles",
        "link":"/news",
    },
    {
        "role":"user",
        "name":"Home",
        "link":"/home",},
    // },
    // {
    //     "role":"user",
    //     "name":"Calmness",
    //     "link":"/calm",
    // },
    // {
    //     "role":"user",
    //     "name":"calendar",
    //     "link":"/management",
    // },
    {
        "role":"user",
        "name":"events",
        "link":"/events",
    }
]